import { Button, IconButton } from "@mui/joy";
import { Gear } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

export function ProfileButtonSettings() {
    const navigate = useNavigate();

    return (
        <IconButton
            variant="soft"
            color="primary"
            onClick={() => navigate('/settings')}
            sx={(theme) => ({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '2px',
                px: 2,
                py: 1,
                width: '56px',
                borderRadius: "999px",
                color: theme.palette.mode === 'dark'
                    ? theme.palette.primary[100]
                    : null,
                fontSize: '12px',
                '& svg': {
                    width: '24px',
                    height: '24px',
                }
            })}
        >
            <Gear size={24} />
        </IconButton>
    )
}
